import { __decorate } from "tslib";
import { AutoEncoder, field, IntegerDecoder } from '@simonbackx/simple-encoding';
export class ReduceablePrice extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.price = 0;
        this.reducedPrice = null;
    }
    getPrice(isReduced) {
        if (this.reducedPrice === null) {
            return this.price;
        }
        return isReduced ? this.reducedPrice : this.price;
    }
    forMember(member) {
        return this.getPrice(member.patchedMember.details.shouldApplyReducedPrice);
    }
}
__decorate([
    field({ decoder: IntegerDecoder })
], ReduceablePrice.prototype, "price", void 0);
__decorate([
    field({ decoder: IntegerDecoder, nullable: true })
], ReduceablePrice.prototype, "reducedPrice", void 0);
//# sourceMappingURL=ReduceablePrice.js.map